module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C155"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('img', {
    staticClass: "Image105",
    attrs: {
      "alt": "",
      "src": "img/10_1.png",
      "width": "71%"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('p', {
    staticClass: "C114_13"
  }, [_c('em', [_vm._v("Author, August 1955")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "C155"
  }, [_c('img', {
    staticClass: "Image103",
    attrs: {
      "alt": "",
      "src": "img/10_2.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "C114_13"
  }, [_c('em', [_vm._v("Author")]), _vm._v(", far right, "), _c('em', [_vm._v("discussing")]), _vm._v(" Al Yawm"), _c('em', [_vm._v("’s political line in Baqa al-Gharbiyya, 1963")]), _vm._v(".")])]), _c('p', {
    staticClass: "C155"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('img', {
    staticClass: "Image103",
    attrs: {
      "alt": "",
      "src": "img/11_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('p', {
    staticClass: "C114_13"
  }, [_c('em', [_vm._v("Author")]), _vm._v(", second from left, "), _c('em', [_vm._v("with Jacqueline Kahanoff")]), _vm._v(", second from right, "), _c('em', [_vm._v("and hosts in Acre, 1964")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "C155"
  }, [_c('img', {
    staticClass: "Image103",
    attrs: {
      "alt": "",
      "src": "img/11_2.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "C114_13"
  }, [_c('em', [_vm._v("Author with wife, Rachel, and their three sons")]), _vm._v(": left to right, "), _c('em', [_vm._v("Rony, Amir, and Elan, 1965")]), _vm._v(".")])]), _c('p', {
    staticClass: "C155"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_c('img', {
    staticClass: "Image103",
    attrs: {
      "alt": "",
      "src": "img/12_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_c('p', {
    staticClass: "C114_13"
  }, [_c('em', [_vm._v("Author")]), _vm._v(", third from right, "), _c('em', [_vm._v("with reporters and hosts in Taiba, 1965")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "C155"
  }, [_c('img', {
    staticClass: "Image103",
    attrs: {
      "alt": "",
      "src": "img/12_2.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "C114_6"
  }, [_vm._v("Left to right: "), _c('em', [_vm._v("Elan, Amir, and Rony, 1966")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28c67c42","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Image.vue
// module id = 72
// module chunks = 0